import { useState } from 'react'

/** Rows a page on every list (docs/plans/lists-orders-style.md). */
export const PAGE_SIZE = 25

/**
 * One page of a list that is read whole (the Menu, Ingredients, Payments made…): the rows
 * to show and what `Pagination` needs. A new `scope` (the search, the filters) starts again
 * at the first page; a list that shrank under the page it was on shows its last page.
 */
export function usePaged<T>(items: readonly T[], scope: string, size = PAGE_SIZE) {
  const [state, setState] = useState({ scope, offset: 0 })
  if (state.scope !== scope) setState({ scope, offset: 0 })
  const wanted = state.scope === scope ? state.offset : 0
  const last = items.length === 0 ? 0 : Math.floor((items.length - 1) / size) * size
  const offset = Math.min(wanted, last)
  return {
    rows: items.slice(offset, offset + size),
    offset,
    limit: size,
    total: items.length,
    setOffset: (next: number) => setState({ scope, offset: next }),
  }
}
